import {get, post} from './api'

export default {
    getInstaplayUsingID(id) {
        return get('/getInstaplayUsingID',{InstaplayID: id})
    },

    fetchInstaplayIDs() {
        return get('/fetchInstaplayIDs')
    },

    fetchUserInstaplayIDs(token, mode) {
        // let url = '/fetchInstaplayIDs'
        let url = 'userInstaplayIDs'
        if (mode === 'active') url = '/detailedUserActivePlaysWithInstaplayIDs'
        else if (mode === 'completed') url = '/userCompletedPlays'
        else if (mode.startsWith('manage')) {
            url = '/gmInstaplayIDs'
            return get(url, {token, filter: mode.slice(6).toLowerCase()})
        }
        return get(url, {token})
    },

    fetchAdminUserInstaplayIDs(adminToken, userid, mode) {
        let url
        if (mode === 'active') url = '/detailedUserActivePlaysWithInstaplayIDs'
        else if (mode === 'completed') url = '/userCompletedPlays'
        return get(url, {adminToken, userid})
    },

    playInstaplay(params) {
        return get('/play', params)
    },

    modifyPlay(params) {
        return get('/modifyPlay', params)
    },

    deletePlay(params) {
        return get('/deletePlay', params)
    },

    createInstaplay(payload) {
        payload = JSON.parse(JSON.stringify(payload))
        // console.log(payload)
        // return {Success: ''}
        return post('/createInstaplay', payload)
    },

    getTournaments(token) {
        return get('/getTournaments', {token})
    },

    getEmailGroups(token) {
        return get('/getEmailGroups', {token})
    },

    declareWinner(payload) {
        const cap = payload.InstaplayType.charAt(0).toUpperCase() + payload.InstaplayType.slice(1)
        const url = '/declare' + cap + 'Winner'
        return get(url, payload)
    },

    getInstaplayOutcome(params) {
        return get('/getInstaplayOutcome', params)
    },

    getThumbnails(params) {
        return get('/getThumbnails', params)
    },

    openCloseInstaplay(params, val) {
        let url = `/${val}Instaplay`
        return get(url, params)
    },

    getPoolBalance(params) {
        return get('/poolBalance', params)
    },

    deleteInstaplay(params) {
        return get('/deleteInstaplay', params)
    }
}
